const configuredApiBaseUrl = process.env.REACT_APP_API_BASE_URL;
const defaultApiBaseUrl =
  process.env.NODE_ENV === "development" ? "http://localhost:8000" : "";

export const API_BASE_URL = configuredApiBaseUrl
  ? configuredApiBaseUrl.replace(/\/+$/, "")
  : defaultApiBaseUrl;
